// ADMIN_OR_SALES_USER_ID/FACILITY_ID/IS_LOGIN_THROUGH_* are assigned straight from
// queryString.parse() in useWebRedirect (string | string[] | null), not normalized —
// callers only ever truthy-check or forward them as-is.
interface AdminSalesRedirectSession {
  HOST_REDIRECT_URL: string | undefined;
  REDIRECT_ADMIN_OR_SALES_URL: string | undefined;
  ADMIN_OR_SALES_USER_ID: string | string[] | undefined;
  ADMIN_OR_SALES_FACILITY_ID: string | string[] | undefined;
  IS_LOGIN_THROUGH_ADMIN: string | string[] | undefined;
  IS_LOGIN_THROUGH_SALES: string | string[] | undefined;
}

// Runtime-mutable state (NOT env vars): written by WebRedirect/App during the
// admin–sales login flow, then read by AuthenticationGate.
const CONFIG: AdminSalesRedirectSession = {
  HOST_REDIRECT_URL: undefined,
  REDIRECT_ADMIN_OR_SALES_URL: undefined,
  ADMIN_OR_SALES_USER_ID: undefined,
  ADMIN_OR_SALES_FACILITY_ID: undefined,
  IS_LOGIN_THROUGH_ADMIN: undefined,
  IS_LOGIN_THROUGH_SALES: undefined,
};

export default CONFIG;
